import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,

} from "@mui/material";
import { withStyles } from "@mui/styles"
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  deleteAnalyticsConnection,
  fetchGAModelData,
  fetchGA_URL,
  fetchGaDataViewsPropertiesAction,
  storeSearchEngineId,
} from "../../actions";
import {
  NewOrangeContainedBtn,
  NewOutLinedRectCancelBlueBtn,
} from "../../components/buttons";

import { ConnectionTypeTypography, ErrorTypography } from "../../components/typography";
import SnackbarWrapperConnections from "../snackbars";
import MySnackbarWrapper from "../snackbars";
import { fetchAuthGoogleAnalytics_URL, fetchGoogleAnalyticsViewsAndPropertiesNewDashboard } from "../../actions/googleAnalyticsNewDashboard";
import icons from "../../components/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const styles = (theme) => ({
  GaGrid: {
    backgroundColor: "#FFFFFF",
    [theme.breakpoints.up("md")]: {
      width: "100%",
      height: "88px",
      border: "solid 2px #BBBBBB",
      borderRadius: "6px",
      padding: "0px 10px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
      width: "100%",
      height: "300px",
      border: "solid 1px #BBBBBB",
      borderRadius: "3px",
      textAlign: "center",
    },
  },
  TextCenter: {
    textAlign: "Center",
    fontSize: "16px",
  },

  gridItems: {
    margin: "Auto 0",
  },
  buttons: {
    backgroundColor: "#F58120",
    border: "solid 1px #1E334E",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  dataStyle: {
    fontWeight: "500",
    color: "#1E334E",
    wordBreak: "break-word",
  },
  verticalLine: {
    paddingRight: "7px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
});

let engineId = 0;

function GoogleAnalyticsConnection(props) {
  window.scrollTo(0, 0);
  const classes = props.classes;

  const {
    fetchGA_URL,
    storeSearchEngineId,
    googleAnalyticsURLDataReducers,
    fetchGAModelDataReducers,
    deleteAnalyticsConnection,
    deleteConnectionsDataReducer,
    fetchGaDataViewsPropertiesAction,
    googleAnalyticsData,
    userInformationReducer,
    fetchAuthGoogleAnalytics_URL,
    fetchAuthGoogleAnalytics_URLReducer,
    fetchGoogleAnalyticsViewsAndPropertiesNewDashboard,
  } = props;

  useEffect(() => {
    // fetchGA_URL(); used this for the google analytics dashboard.

    fetchAuthGoogleAnalytics_URL(userInformationReducer.selectedClientInfo.clientId, "LXRGUIDE")
  }, [userInformationReducer.selectedClientInfo.clientId]);

  var authUrl = fetchAuthGoogleAnalytics_URLReducer["authUrl"];


  const [analyticsAccountNameGA4, setAnalyticsAccountNameGA4] = useState("");
  const [analyticsIdGA4, setAnalyticsIdGA4] = useState("");
  const [propertyIdGA4, setPropertyIdGA4] = useState("");
  const [alert, setAlert] = useState(false);
  const [clientId, setClientId] = useState();
  const history = useHistory();
  const [snackbar, setSnackbar] = useState({
    message: "",
    variant: "success",
  });


  useEffect(() => {
    if (googleAnalyticsData) {
      setAnalyticsAccountNameGA4(
        googleAnalyticsData.accountName ? googleAnalyticsData.accountName : "-"
      );
      setAnalyticsIdGA4(
        googleAnalyticsData.analyticsId ? googleAnalyticsData.analyticsId : "-"
      );
      setPropertyIdGA4(
        googleAnalyticsData.propertyId ? googleAnalyticsData.propertyId : "-"
      );
      setClientId(googleAnalyticsData.clientId);
    }
  }, [googleAnalyticsData]);

  const handleAddAccountGA4 = async (addAccountStatus) => {
    if (authUrl != undefined && authUrl != "") {
      let newWindow =  window.open(authUrl, "Google Analytics Authentication",
        "menubar=no,status=no,location=no,toolbar=no,scrollbars=yes,resizable=no, width=700, height=600, top=30");

      const checkWindowStatus = setInterval(async () => {
        if (newWindow && newWindow.closed) {
          clearInterval(checkWindowStatus);
          if(addAccountStatus){
            window.location.href =("dashboard.html#/properties-views");
          }else{
            const data = await fetchGoogleAnalyticsViewsAndPropertiesNewDashboard(addAccountStatus, clientId, analyticsIdGA4, "LXRGuide");
            if(data != null && data.refreshTokenUpdate == true){
              setSnackbar({
                message: "Refresh tokens updated.",
                variant: "success",
              })
          } else{
            setSnackbar({
              message: "Error in updating tokens.",
              variant: "error",
            })
          }
          setAlert(true);
        }
      }}, 3000);
    }
  };

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const onClose = () => {
    setOpen(false);
  };
  const handleDialogToOpen = () => {
    setOpen(true);
  };

  const handleDialogToClose = () => {
    setOpen(false);
  };

  const [deleteObjectAccountName, setDeleteObjectAccountName] = useState("");

  const handleDeleteConnection = async (analyId, analyAccName, analyPropertyId) => {
    setDeleteObjectAccountName(analyAccName);
    await deleteAnalyticsConnection(analyId);
    setOpen(false);
    setSnackbar({
      open: true,
      message: "GA 4 account deleted successfully",
      variant: "success",
    })
    setAlert(true);
  };

  useEffect(() => {
    if (deleteConnectionsDataReducer.message === "DELETE_ANALY_CONNECTION_RECEIVED") {
      if (deleteObjectAccountName === analyticsAccountNameGA4) {
        setAnalyticsAccountNameGA4("");
        setPropertyIdGA4("");
      }
    }
  }, [deleteConnectionsDataReducer]);

  const handleCloseAlert = async () => {
    await setAlert(false);
  };
  const [showGoogleAnalyComponentStatus, setShowGoogleAnalyComponentStatus] =
    useState(false);
  const showGoogleAnalyComponent = () => {
    setShowGoogleAnalyComponentStatus(true);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container className={classes.GaGrid}>
        <Grid item xs={12} sm={12} md={3} lg={3} className={classes.gridItems}>
          <div className={classes.flexCenter}>
            {icons.GoogleAnalytics}
            <ConnectionTypeTypography>Google Analytics 4</ConnectionTypeTypography>
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3} className={classes.gridItems}>
          {analyticsAccountNameGA4 === "" || analyticsAccountNameGA4 === "-" ? (
            <Typography></Typography>
          ) : (
            <div className={classes.flexCenter}>
              <div className={classes.verticalLine}>
                {icons.SegregationLine}
              </div>
              <Typography style={{ color: "#747474" }}>
                Account Name:
                <br />
                <span className={classes.dataStyle}>{analyticsAccountNameGA4}</span>
              </Typography>
            </div>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} className={classes.gridItems}>
          {propertyIdGA4 === "" || propertyIdGA4 === "-" ? (
            <Typography></Typography>
          ) : (
            <div className={classes.flexCenter}>
              <div className={classes.verticalLine}>
                {icons.SegregationLine}
              </div>
              <Typography style={{ color: "#747474" }}>
                Property Id:
                <br />
                <span className={classes.dataStyle}>{propertyIdGA4}</span>
              </Typography>
            </div>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} className={classes.gridItems}>
          {googleAnalyticsData !== undefined &&
            (deleteConnectionsDataReducer["message"] === "" ||
              deleteConnectionsDataReducer["message"] ===
              "DELETE_ANALY_CONNECTION_FAILED") ? (
            <Typography>
              <NewOutLinedRectCancelBlueBtn
              onClick={()=>handleAddAccountGA4(false)}>
                Refresh Token
              </NewOutLinedRectCancelBlueBtn>
            </Typography>
          ) : (
            <Typography></Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} className={classes.gridItems}>
          {googleAnalyticsData != undefined &&
            (deleteConnectionsDataReducer["message"] === "" ||
              deleteConnectionsDataReducer["message"] ===
              "DELETE_ANALY_CONNECTION_FAILED") ? (
            <Typography>
              <NewOutLinedRectCancelBlueBtn onClick={handleDialogToOpen}>
                Delete Account
              </NewOutLinedRectCancelBlueBtn>
            </Typography>
          ) : (
            <Typography>
              <NewOrangeContainedBtn onClick={()=>handleAddAccountGA4(true)} autoFocus={true} focusRipple={true}>
                +Add Account
              </NewOrangeContainedBtn>
            </Typography>
          )}
        </Grid>
      </Grid>

      {/* Snackbar for error in deleting google analytics account */}
      <Grid container>
        <Grid item md={12}>
          {deleteConnectionsDataReducer.response === true ? (
            <React.Fragment>
              <SnackbarWrapperConnections
                open={open}
                onClose={onClose}
                message={message}
                verticalAlign={"bottom"}
                horizontalAlign={"right"}
                duration={6000}
                variant={"error"}
              />
            </React.Fragment>
          ) : deleteConnectionsDataReducer.response === false ? (
            <ErrorTypography className={classes.TextCenter}>
              Error deleting the Account
            </ErrorTypography>
          ) : null}
        </Grid>
      </Grid>

      <Dialog open={open} onClose={handleDialogToClose}>
        <DialogTitle>{"Delete Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you really want to delete the Google Analytics 4 integration in LXRGuide?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              handleDeleteConnection(
                analyticsIdGA4,
                analyticsAccountNameGA4,
                propertyIdGA4
              )
            }
            color="primary"
            autoFocus
          >
            Delete
          </Button>
          <Button onClick={handleDialogToClose} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <MySnackbarWrapper
        open={alert}
        onClose={handleCloseAlert}
        message={snackbar.message}
        verticalAlign={"bottom"}
        horizontalAlign={"right"}
        duration={6000}
        variant={snackbar.variant}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  googleAnalyticsURLDataReducers: state.googleAnalyticsURLDataReducers,
  connectionsDataReducer: state.connectionsDataReducer,
  fetchDataAndStoreEngIdDataReducers: state.fetchDataAndStoreEngIdDataReducers,
  fetchGAModelDataReducers: state.fetchGAModelDataReducers,
  deleteConnectionsDataReducer: state.deleteConnectionsDataReducer,
  fetchPropertiesAndViewsDataReducer: state.fetchPropertiesAndViewsDataReducer,
  userInformationReducer: state.userInformation,
  fetchAuthGoogleAnalytics_URLReducer: state.fetchAuthGoogleAnalytics_URLReducer
});
const mapDispatchToProps = (dispatch) => ({
  // fetchGA_URL: () => dispatch(fetchGA_URL()), // for the google analytics dashboard
  fetchAuthGoogleAnalytics_URL: (clientId, applicationName) => dispatch(fetchAuthGoogleAnalytics_URL(clientId, applicationName)),

  storeSearchEngineId: (engineId) => dispatch(storeSearchEngineId(engineId)),
  fetchGAModelData: (accountId, propertyId, profileId) =>
    dispatch(fetchGAModelData(accountId, propertyId, profileId)),
  deleteAnalyticsConnection: (analyId) =>
    dispatch(deleteAnalyticsConnection(analyId)),
  fetchGaDataViewsPropertiesAction: (refreshTokenStatus, analyId) =>
    dispatch(fetchGaDataViewsPropertiesAction(refreshTokenStatus, analyId)),
  fetchGoogleAnalyticsViewsAndPropertiesNewDashboard : (addAccountStatus, clientId, analyticsId, applicationName) =>
    dispatch(fetchGoogleAnalyticsViewsAndPropertiesNewDashboard(addAccountStatus, clientId, analyticsId, applicationName))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(GoogleAnalyticsConnection));
